$(function() {

  var dirRtlFlag = false;
  if ($("html").attr('dir') == 'rtl') {
    dirRtlFlag = true;
  }


  $('.proj-slider').slick({
    dots: true,
    arrows: false,
    infinite: true,
    speed: 600,
    autoplay: true,
    autoplaySpeed: 3000,
    rtl: dirRtlFlag,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
    {
        breakpoint: 1300,
        settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        }
        
    },
    {
      breakpoint: 1200,
      settings: {
      slidesToShow: 3,
      slidesToScroll: 1
      }
  },
    {
        breakpoint: 740,
        settings: {
        slidesToShow: 2,
        slidesToScroll: 1
        }
    },
    {
        breakpoint: 480,
        settings: {
        slidesToShow: 1,
        slidesToScroll: 1
        }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
    ]
});

$('.review-slider').slick({
  dots: true,
  arrows: false,
  infinite: true,
  speed: 600,
  autoplay: true,
  autoplaySpeed: 3000,
  rtl: dirRtlFlag,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
  {
      breakpoint: 1300,
      settings: {
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: true,
      }
      
  },
  {
    breakpoint: 1200,
    settings: {
    slidesToShow: 3,
    slidesToScroll: 1
    }
},
  {
      breakpoint: 740,
      settings: {
      slidesToShow: 2,
      slidesToScroll: 1
      }
  },
  {
      breakpoint: 480,
      settings: {
      slidesToShow: 1,
      slidesToScroll: 1
      }
  }
  // You can unslick at a given breakpoint now by adding:
  // settings: "unslick"
  // instead of a settings object
  ]
});

});

$( ".catalog-bottom-text table" ).wrap( "<div class='table-outer-wrap'><div class='table-outer-wrap-inner'></div></div>" );